import { render } from "./MentorPendingRequestsPage.vue?vue&type=template&id=4fe3b013&scoped=true"
import script from "./MentorPendingRequestsPage.vue?vue&type=script&lang=js"
export * from "./MentorPendingRequestsPage.vue?vue&type=script&lang=js"

import "./MentorPendingRequestsPage.vue?vue&type=style&index=0&id=4fe3b013&scoped=true&lang=css"

import exportComponent from "/root/mentoringplatform-acm/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe3b013"]])

export default __exports__